import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1aba328b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-product" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "flex-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"264px","font-size":"14px"} }, " ※「日本搬送」在庫は、中国倉庫で良品登録後に日本倉庫への搬送依頼が必要です。 ", -1))
const _hoisted_6 = { class: "flex-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"264px","font-size":"14px"} }, " ※「直送」在庫は、中国倉庫から直接エンドユーザーに出荷される在庫です。 ", -1))
const _hoisted_8 = { class: "dialog-footer" }

import { QuestionFilled } from '@element-plus/icons-vue'
import { t } from '@/plugins/i18n'
import NewInputBatchSearch from '@/components/NewInputBatchSearch/index.vue'
import Pagination from '@/components/common/pagination/index.vue'
import dblclick from '@/components/BatchSearch/index'
import { isJA, isChoiceShop } from '@/store'
import { reactive, ref, nextTick, watch, computed } from 'vue'
import STable from '@/components/Table/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { shippingProductColumns, shippingProductColumnsEn, replenishmentProductColumns, stockJPProductColumns } from './data'
import { getCustomerProductSkuListApi } from '@/apis/inShipping'
import { clearForm } from '@/util/common'
import { debounce } from 'lodash'

export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'type', 'addList', 'countryCode', 'allIncludeFlag', 'isCrossMallGoods', 'isStockJp'],
  emits: ['update:visible', 'getList'],
  setup(__props, { emit: emits }) {

const props = __props
 // type 1 国际发货 2 补货计划


const productTableConfig = {
  showSelection: true
}

const paginationConfig = {
  layout: 'prev, pager, next'
}

const pageData = ref({
  page: 1,
  limit: 50
})

const form = reactive({
  keywordSku: '',
  amazonKeywordSku: ''
})
const keyword = ref([])
const skuType = ref('')
const keywordSku = computed({
  get: () => props.type === 1 ? form.keywordSku : form.amazonKeywordSku,
  set: (v) => {
    if (props.type === 1) {
      form.keywordSku = v
    } else {
      form.amazonKeywordSku = v
    }
  }
})
const columns = computed(() => {
  if (props.isStockJp) return stockJPProductColumns
  let list = (props.type === 1 ? isJA() ? shippingProductColumns : shippingProductColumnsEn : replenishmentProductColumns).filter((v) => props.allIncludeFlag ? true : v.prop !== 'allIncludeUseable').filter((v) => props.isStockJp ? v.prop !== 'overseaProductSku' : true)
  if (props.isCrossMallGoods) {
    list = [
      ...list,
      {
        label: 'SKUコード',
        prop: 'crossMallProductSku',
        align: 'center'
      },
      {
        label: '商品名',
        prop: 'crossMallProductTitle',
        align: 'center'
      }
    ]
  }
  return list
})
watch(() => props.visible, (newValue) => {
  if (newValue) {
    isLoading.value = false
    skuType.value = props.type === 1 ? 'productSkus' : 'amazonMskus'
    keyword.value = []
    clear()
    getTableData()
  }
})

// 监听分页变化
watch(() => [pageData.value.page, pageData.value.limit], () => {
  // 重新计算当前页数据时保持选中状态
  if (tableData.value.length) {
    syncSelection()
  }
})

// 同步选中状态（跨页保持选中）
const syncSelection = () => {
  if (!STableRef.value || !selectionList.length) return

  // 先清空当前页选中
  STableRef.value.clearSelection()

  // 重新选中当前页中已在选择列表中的项
  currentPageData.value.forEach(row => {
    if (selectionList.some(item => item.shopProductSku === row.shopProductSku)) {
      STableRef.value.toggleRowSelection(row, true)
    }
  })
}

// 当前页数据
const currentPageData = computed(() => {
  const start = (pageData.value.page - 1) * pageData.value.limit
  const end = start + pageData.value.limit
  return tableData.value.slice(start, end)
})


// const show
const tableLoading = ref(false)
const tableData = ref([])
const getTableData = () => {
  tableLoading.value = true
  const params: any = {
    goodsCountry: props.countryCode ?? 'CN'
  }
  if (skuType.value && keyword.value?.length > 0) {
    params[skuType.value] = keyword.value
  }
  getCustomerProductSkuListApi(params).then((res: any) => {
    if (res.success) {
      tableData.value = (res.data || []).filter((e: any) => {
        if (props.addList.findIndex((v: any) => v.shopProductSku === e.shopProductSku) === -1) {
          if (props.allIncludeFlag === 1) {
            return e.allIncludeUseable
          } else if (props.isStockJp) {
            return e.overseasInvUseable
          } else {
            return e.useable > 0
          }
        }
        return false
      })

      nextTick(() => {
        paginationConfig.value.total = tableData.value.length
      })
      console.log(tableData.value)
    }
  }).finally(() => { tableLoading.value = false })
}

let selectionList: any[]
const handleSelection = (val: any[]) => {
  selectionList = val
}

const STableRef = ref()
const clear = () => {
  selectionList = []
  clearForm(form)
}
const isLoading = ref(false)
const submit = () => {
  if (isLoading.value) return
  isLoading.value = true
  emits('getList', selectionList)
  emits('update:visible', false)
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "destroy-on-close": "",
    onClose: _cache[4] || (_cache[4] = ($event: any) => (emits('update:visible', false))),
    draggable: "",
    "custom-class": "add-product-modal"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_8, [
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('update:visible', false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('添加商品')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_form, {
            inline: true,
            model: _unref(form)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: skuType.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((skuType).value = $event)),
                    style: {"width":"140px","height":"32px"},
                    class: "select-sku",
                    "popper-class": "popper-select-sku"
                  }, {
                    default: _withCtx(() => [
                      (__props.type === 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_el_option, {
                              label: _unref(t)('平台SKU'),
                              value: "productSkus"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _unref(t)('客户商品SKU'),
                              value: "customerProductMskus"
                            }, null, 8, ["label"]),
                            (!__props.isStockJp)
                              ? (_openBlock(), _createBlock(_component_el_option, {
                                  key: 0,
                                  label: _unref(t)('海外仓sku'),
                                  value: "overseaProductSkus"
                                }, null, 8, ["label"]))
                              : _createCommentVNode("", true),
                            (__props.isCrossMallGoods)
                              ? (_openBlock(), _createBlock(_component_el_option, {
                                  key: 1,
                                  label: "CROSS MALL sku",
                                  value: "crossMallSkus"
                                }))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_el_option, {
                              label: _unref(t)('平台SKU'),
                              value: "productSkus"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _unref(t)('Amazon sku'),
                              value: "amazonMskus"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _unref(t)('FNSKU'),
                              value: "amazonFnskus"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _unref(t)('ASIN'),
                              value: "amazonAsins"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _unref(t)('海外仓sku'),
                              value: "overseaProductSkus"
                            }, null, 8, ["label"])
                          ], 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(NewInputBatchSearch, {
                    modelValue: keyword.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((keyword).value = $event)),
                    placeholder: _unref(t)('双击批量搜索'),
                    style: {"width":"230px","height":"32px"},
                    class: "order-item-input"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: getTableData,
                    style: {"height":"32px","min-width":"88px","margin-left":"-16px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _withDirectives(_createVNode(STable, {
          ref: (_value, _refs) => {
            _refs['STableRef'] = _value
            STableRef.value = _value
          },
          "table-data": _unref(currentPageData),
          columns: _unref(columns),
          showPagination: false,
          "table-config": productTableConfig,
          "max-height": "480",
          onSelectionChange: handleSelection
        }, {
          productMainImg: _withCtx(({ row }) => [
            _createVNode(ShoppingPreview, {
              image: row.productSkuImg || row.productMainImg || ''
            }, null, 8, ["image"])
          ]),
          productSkuInfo: _withCtx(({ row }) => [
            _createElementVNode("p", null, _toDisplayString(row.productSku ?? ''), 1),
            _createElementVNode("p", null, _toDisplayString(row.productTitle ?? ''), 1),
            _createElementVNode("p", null, _toDisplayString(row.productPropertiesName ?? ''), 1)
          ]),
          amazonMsku: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.amazonMsku ?? '') + "/" + _toDisplayString(row.amazonProductTitle ?? ''), 1)
          ]),
          amazonFnsku: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.amazonFnsku ?? '') + "/" + _toDisplayString(row.amazonAsin ?? ''), 1)
          ]),
          overseasInvCheckedHead: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('良品数(仅可备货)')), 1),
              _createVNode(_component_el_tooltip, {
                effect: "light",
                placement: "top",
                "popper-class": "tool-tip-no-border"
              }, {
                content: _withCtx(() => [
                  _hoisted_5
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, {
                    color: "#999",
                    class: "cursor-pt"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(QuestionFilled))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          useableHead: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('良品数(仅可直发)')), 1),
              _createVNode(_component_el_tooltip, {
                effect: "light",
                placement: "top",
                "popper-class": "tool-tip-no-border"
              }, {
                content: _withCtx(() => [
                  _hoisted_7
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, {
                    color: "#999",
                    class: "cursor-pt"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(QuestionFilled))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["table-data", "columns"]), [
          [_directive_loading, tableLoading.value]
        ]),
        _createVNode(Pagination, {
          style: {"margin-top":"10px"},
          showPagination: true,
          total: tableData.value.length,
          "page-data": pageData.value,
          "onUpdate:page-data": _cache[2] || (_cache[2] = ($event: any) => ((pageData).value = $event)),
          paginationConfig: paginationConfig
        }, null, 8, ["total", "page-data"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})